// IST timezone utility for consistent date handling
export const formatToIST = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  
  return d.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
};

export const formatDateTimeForInput = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  
  // Get IST time components
  const istTime = d.toLocaleString('sv-SE', { timeZone: 'Asia/Kolkata' });
  
  // Return in YYYY-MM-DDTHH:mm format for datetime-local input
  return istTime.slice(0, 16);
};

export const getCurrentISTDateTime = () => {
  return new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
};

export const parseISTDateTime = (dateTimeString) => {
  if (!dateTimeString) return null;
  
  // Parse the datetime-local input as IST and convert to UTC for storage
  const istDate = new Date(dateTimeString + ':00+05:30');
  return istDate.toISOString();
};